import { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SettingsLayout.css';

interface SettingsLayoutProps {
  children: ReactNode;
}

function SettingsLayout({ children }: SettingsLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { label: 'Profile', path: '/settings' },
    { label: 'Billing', path: '/settings/billing' },
    { label: 'Security', path: '/settings/security' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="container">
      <div className="settings-layout">
        <div className="settings-sidebar">
          <div className="settings-sidebar-desktop">
            <h3 className="settings-sidebar-title">Settings</h3>
            <nav className="settings-menu">
              {menuItems.map((item) => (
                <button
                  key={item.path}
                  className={`settings-menu-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="settings-mobile-nav">
            <label htmlFor="settings-section" className="settings-mobile-nav-label">
              Settings section
            </label>
            <select
              id="settings-section"
              value={location.pathname}
              onChange={(e) => navigate(e.target.value)}
              className="settings-mobile-nav-select"
            >
              {menuItems.map((item) => (
                <option key={item.path} value={item.path}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="settings-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default SettingsLayout;
